export const AUTH = "AUTH"
export const AUTH_LOGIN = "AUTH_LOGIN"
export const AUTH_LOGOUT = "AUTH_LOGOUT"

export const AUTH_INIT = "AUTH_INIT"
export const API_LOADING = "API_LOADING"
